export default __webpack_public_path__ + "static/media/DIY06.17c8171e.JPG";